import { useState, useEffect } from "react";
import i18next from "i18next";
import { getCurrentLanguage } from "../../../helpers/Utils";

const LanguageToggleSwitch = ({ className = "" }) => {
  const [lang, setLang] = useState(getCurrentLanguage());

  useEffect(() => {
    i18next.changeLanguage(lang);
  }, [lang]);

  const handleChange = (e) => {
    setLang(e.target.value);
  };

  return (
    <select
      value={lang}
      onChange={handleChange}
      className={className}
      style={{
        border: "1px solid #ee7225",
        borderRadius: "6px",
        padding: "4px 10px",
        fontSize: "13px",
        fontWeight: 600,
        color: "#ee7225",
        background: "#fff",
        cursor: "pointer",
        outline: "none",
      }}
    >
      <option value="en">English</option>
      <option value="es">Spanish</option>
    </select>
  );
};

export default LanguageToggleSwitch;
